import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import SpecialPreview from "@/pages/home/components/SpecialPreview";
import SectionHeader from "@/components/feature/SectionHeader";
import MovieGrid from "@/components/feature/MovieGrid";
import { usePageMeta } from "@/hooks/usePageMeta";
import { heroSlides, siteInfo } from "@/mocks/site";
import { allMovies, getLatestMovies, getPopularMovies } from "@/utils/content";

const HOME_TDK = {
  title: "秘密影院-专业电影电视剧免费在线观看平台",
  description:
    "秘密影院为您提供丰富的电影、电视剧资源，涵盖多种类型和热门影视作品，满足您的观影需求。尽享精彩影视内容，轻松查找最新影视资讯。",
  keywords: "秘密影院,电影,电视剧,影视平台,在线视频,影视资源,影视推荐"
};

export default function Home() {
  usePageMeta(HOME_TDK);

  const latest = getLatestMovies(8);
  const popular = getPopularMovies(8);

  const stats = [
    { value: `${allMovies.length}+`, label: "在库影视作品", accent: true },
    { value: "5", label: "内容类型", accent: false },
    { value: "每 日", label: "持续更新", accent: false }
  ];

  return (
    <div>
      <HeroCarousel slides={heroSlides} />

      <section className="border-b border-background-800 bg-background-900/50">
        <div className="w-full px-4 py-10 md:px-6 md:py-14">
          <div className="grid gap-8 lg:grid-cols-[1.6fr_1fr] lg:items-center">
            <div>
              <h1 className="font-heading text-2xl font-800 leading-tight text-foreground-50 md:text-4xl">
                秘密影院 · 专业电影电视剧免费在线观看平台
              </h1>
              <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-400 md:text-base">
                {siteInfo.intro}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to="/search"
                  className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-700 text-background-950 transition-colors hover:bg-accent-600"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-search-line" aria-hidden="true" />
                  </span>
                  搜索影视
                </Link>
                <Link
                  to="/category/all"
                  className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-600 px-6 py-2.5 text-sm font-600 text-foreground-200 transition-colors hover:border-secondary-500 hover:text-secondary-300"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-grid-line" aria-hidden="true" />
                  </span>
                  浏览全部资源
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-800 bg-background-950/60 p-4 text-center"
                >
                  <p
                    className={`font-heading text-xl font-800 md:text-2xl ${
                      stat.accent ? "text-accent-400" : "text-foreground-50"
                    }`}
                  >
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeader
          title="分类快捷入口"
          subtitle="按内容类型快速进入你想看的影视频道"
        />
        <CategoryGrid />
      </section>

      <section className="border-y border-background-800 bg-background-900/40">
        <div className="w-full px-4 py-10 md:px-6 md:py-14">
          <SectionHeader
            title="最新影视更新"
            subtitle="近期上架与更新的影视作品，第一时间 discover"
            moreHref="/category/all"
          />
          <MovieGrid movies={latest} />
        </div>
      </section>

      <section className="w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeader
          title="热门影视精选"
          subtitle="综合评分与关注度，为你挑选近期高口碑作品"
          moreHref="/category/all"
        />
        <MovieGrid movies={popular} />
      </section>

      <section className="border-y border-background-800 bg-background-900/40">
        <div className="w-full px-4 py-10 md:px-6 md:py-14">
          <SectionHeader
            title="推荐专题"
            subtitle="跟着主题一次看个够，发现更多同类型好片"
          />
          <SpecialPreview />
        </div>
      </section>

      <section className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-6 rounded-lg border border-background-800 bg-primary-950 p-6 md:grid-cols-[1.5fr_1fr] md:items-center md:p-10">
          <div>
            <h2 className="font-heading text-xl font-700 text-foreground-50 md:text-2xl">
              关于秘密影院
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-300">
              {siteInfo.scope}
            </p>
          </div>
          <div className="flex md:justify-end">
            <Link
              to="/about"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-700 text-background-950 transition-colors hover:bg-accent-600"
            >
              了解我们
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-s-line" aria-hidden="true" />
              </span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}